export const ACTIVATE_PROMO_CODES_REQUEST = 'ACTIVATE_PROMO_CODES_REQUEST';
export const ACTIVATE_PROMO_CODES_SUCCESS = 'ACTIVATE_PROMO_CODES_SUCCESS';
export const ACTIVATE_PROMO_CODES_FAIL = 'ACTIVATE_PROMO_CODES_FAIL';
export const ACTIVATE_PROMO_CODES_RESET = 'ACTIVATE_PROMO_CODES_RESET';

export const ADD_PROMO_CODES_REQUEST = 'ADD_PROMO_CODES_REQUEST';
export const ADD_PROMO_CODES_SUCCESS = 'ADD_PROMO_CODES_SUCCESS';
export const ADD_PROMO_CODES_FAIL = 'ADD_PROMO_CODES_FAIL';
export const ADD_PROMO_CODES_RESET = 'ADD_PROMO_CODES_RESET';